import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { get } from '../../../utils/fetchAPI';
import SearchSelect from '../../common/updated-input/createble-search-select/search-select';
import "./resarchTag.scss"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import CustomModal from '../../common/modal/modal';

export const ResearchTagAssign = ({ handleTags, visitDetails, removeTags,className="",placeholder="Assign tags" }) => {
    const { user } = useSelector((state) => state.auth);
    const [tagList, setTagList] = useState([])
    const [selectedTags, setSeletedTags] = useState([])
    const [showTagsModal, setShowTagsModal] = useState(false)
    let timeoutIdRef = useRef()

    useEffect(() => {
        getTagList(user?.user?._id)
    }, [])

    const getTagList = async (doctorId = user?.user?._id, search = "") => {
        await get(`/doctor/tag/list/${doctorId}${search ? "?search=" + search : ""}`)
            .then((res) => {
                if (res?.status == 200) {
                    setTagList(res?.data?.tags)
                }
            })
            .catch((error) => {
                // setIsSubmitting(false);
            });;
    }

    // const handleSubmit = (value) => {
    //     console.log("check", value)

    // }

    const setOptionFun = (event) => {
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(async () => {
            getTagList(user?.user?._id, event?.target?.value || "")
        }, 700);
    }

    useMemo(() => {
        if (visitDetails?.researchTag) {
            setSeletedTags(visitDetails?.researchTag)
        }
    }, [visitDetails?.researchTag])

    // The modal only exists to look at assigned tags — close it when the last one goes.
    useEffect(() => {
        if (showTagsModal && !(selectedTags?.length > 0)) setShowTagsModal(false)
    }, [selectedTags, showTagsModal])


    return (
        <div className={className?className:'d-flex'}>
            <SearchSelect uniqKey={1} borderColor='#13AC81' handleSubmit={handleTags} isSearching={false} setOptionFun={setOptionFun} options={tagList} placeHolder={placeholder}></SearchSelect>
            {className ?
                <div className='d-flex assign-tags-contaner'>
                    {
                        selectedTags?.length > 0 && selectedTags?.map((tag, index) => {
                            return (
                                <div className='px-2 tag' key={index}>
                                    <p className='d-block'>{tag?.name}  <FontAwesomeIcon onClick={() => { removeTags(tag) }} className="tag-delete" style={{ fontSize: "11px" }} icon={faTrash} /></p>
                                </div>
                            )
                        })
                    }
                </div>
                :
                selectedTags?.length > 0 &&
                <button type='button' className='tags-show-btn' onClick={() => setShowTagsModal(true)}>
                    Show ({selectedTags.length})
                </button>
            }

            <CustomModal show={showTagsModal} setShow={setShowTagsModal} autoClose={true} size='sm' customClass='assigned-tags-modal'>
                <div className='assigned-tags-modal-body p-3'>
                    <p className='assigned-tags-title'>Assigned tags</p>
                    {
                        selectedTags?.map((tag, index) => {
                            return (
                                <div className='assigned-tag-row' key={tag?._id || index}>
                                    <span className='assigned-tag-name'>{tag?.name}</span>
                                    <FontAwesomeIcon icon={faTrash} className='assigned-tag-delete' onClick={() => { removeTags(tag) }} />
                                </div>
                            )
                        })
                    }
                </div>
            </CustomModal>

        </div>
    )
}
